import { fileTypesEnum } from "../../../../enums/errors/accounts/general/fileTypes.enum";
import { websiteConfigurationEnum } from "../../../../enums/websiteConfigurations/websiteConfigurationType.enum";
import useWebsiteConfiguration from "../../../../hooks/useWebsiteConfiguration";
import FileInputElementComponent from "../../../general/elements/inputElements/FileInputElementComponent";
import ManageBannersTableComponent from "./ManageBannersTableComponent";

export const WebsiteConfigurationHomeBannerSection = ({ props }) => {
  const { currentValue, handleChange, handleDelete } = props;
  const banners = useWebsiteConfiguration(websiteConfigurationEnum.HomeBanner);

  const getExistingBannersTable = () => {
    return <ManageBannersTableComponent banners={banners} onDelete={handleDelete} />;
  };

  const getBannerInputElement = () => {
    const inputProps = {
      label: "תמונות באנר",
      name: "productImage",
      value: currentValue.Url,
      fileType: fileTypesEnum.image,
      onChange: handleChange,
    };
    return <FileInputElementComponent props={inputProps} />;
  };

  return (
    <>
      {getExistingBannersTable()}
      {getBannerInputElement()}
    </>
  );
};

export default WebsiteConfigurationHomeBannerSection;
